import React from 'react'
import { Col, Row } from 'react-bootstrap'
import NumberFormat from 'react-number-format'
import './headerDetails.css'
import { HEADER_DETAILS_KEYS } from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next'

export default function CardLessCashHeaderDetails({ option = {} }) {
  const { t } = useTranslation()
  return (
    <div className='approval-card-header '>
      <span>
        <span className='span1'>{t(HEADER_DETAILS_KEYS.MOBILE_NO)} : {option?.mobileNumber}</span>
      </span>
      <span>
        <span className='span1'>
        {t(HEADER_DETAILS_KEYS.AMOUNT)} : {option.amount} {option.txnCurrency}
        </span>
        <span className='mt-2 span2 text-right'>{t(HEADER_DETAILS_KEYS.EXPIRY)} : {option.expiry}</span>
      </span>
    </div>
  )
}
